<template>
  <div class="container fluid">
    <v-card>
      <v-toolbar
        dark
        tabs
        flat
        color="primary white--text"
      >
        <v-toolbar-title class="justify-center">
          <h1 class="display-1 headline text--accent-1">
            Payouts
          </h1>
        </v-toolbar-title>
        <v-spacer />
        <v-flex
          xs12
          md2
        >
          <v-select
            v-model="filterByType"
            :items="filterTypes()"
            label="Filter By Payout Type"
            item-key="id"
            item-text="name"
            item-value="id"
            class="mt-2"
            @change="refresh()"
          />
        </v-flex>
      </v-toolbar>
      <v-toolbar
        dark
        tabs
        flat
        color="primary white--text"
        height="72px"
      >
        <v-tabs
          v-model="tab"
          slider-color="amber"
          grow
          color="primary"
          centered
          icons-and-text
        >
          <v-tab
            v-for="(item, id) in tabs"
            :key="id"
            :href="`#${id}`"
          >
            <span>{{ item.title }}</span>
            <v-badge
              :color="
                getLoadingState(id) ?
                  'grey' :
                  (getNotificationCount(id) > 0 ? 'orange' : 'green')"
            >
              <template v-slot:badge>
                <v-progress-circular
                  v-if="getLoadingState(id)"
                  indeterminate
                  color="primary"
                  size="16"
                />
                <v-icon
                  v-else-if="getNotificationCount(id) === 0"
                  dark
                  small
                >
                  done
                </v-icon>
                <span v-else-if="getNotificationCount(id) <= 99">
                  {{ getNotificationCount(id) }}
                </span>
                <span v-else>99+</span>
              </template>
              <v-icon>{{ item.icon }}</v-icon>
            </v-badge>
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="secondary"
              fab
              dark
              absolute
              top
              left
              @click.stop="refresh"
              v-on="on"
            >
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>
        <v-tab-item
          v-for="(item, id) in tabs"
          :key="id"
          :value="`${id}`"
        >
          <v-card flat>
            <component :is="item.component" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import {
  PayoutApprovals,
  HolderApprovals,
  HolderEnrichment,
  BankTransferApprovals,
  FinalCheckApproval,
} from '@/components/payoutsAndTaxes';

export default {
  name: 'PayoutsView',
  components: {
  },
  data() {
    return {
      tab: null,
      filterByType: null,
      tabs: {
        payoutApproval: {
          title: 'Payout Approvals',
          icon: 'check_box',
          component: PayoutApprovals,
        },
        holderEnrichment: {
          title: 'Holder Enrichment',
          icon: 'group',
          component: HolderEnrichment,
        },
        holderApproval: {
          title: 'Holder Approval',
          icon: 'grading',
          component: HolderApprovals,
        },
        bankTransferApproval: {
          title: 'Bank Transfer Approval',
          icon: 'account_balance',
          component: BankTransferApprovals,
        },
        finalCheckApproval: {
          title: 'Final Approval',
          icon: 'verified_user',
          component: FinalCheckApproval,
        },
      },
    };
  },
  computed: {
    currentTabName() {
      if (this.tab === null) {
        return '';
      }

      return `${this.tabs[this.tab].title}`;
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    getNotificationCount(panel) {
      switch (panel) {
        case 'payoutApproval':
          return this.$store.getters.getPayoutsApprovalPending
            ? this.$store.getters.getPayoutsApprovalPending.length
            : 0;
        case 'holderEnrichment':
          return this.$store.getters.getPayoutsHolderEnrichmentPending
            ? this.$store.getters.getPayoutsHolderEnrichmentPending.length
            : 0;
        case 'holderApproval':
          return this.$store.getters.getPayoutsHolderApprovalPending
            ? this.$store.getters.getPayoutsHolderApprovalPending.length
            : 0;
        case 'bankTransferApproval':
          return this.$store.getters.getPayoutsBankTransferApprovalPending
            ? this.$store.getters.getPayoutsBankTransferApprovalPending.length
            : 0;
        case 'finalCheckApproval':
          return this.$store.getters.getPayoutsFinalCheckApprovalPending
            ? this.$store.getters.getPayoutsFinalCheckApprovalPending.length
            : 0;
        default:
          return 0;
      }
    },
    getLoadingState(panel) {
      switch (panel) {
        case 'payoutApproval':
          return this.$store.getters.getPayoutsApprovalPendingIsLoading;
        case 'holderEnrichment':
          return this.$store.getters.getPayoutsHolderEnrichmentPendingIsLoading;
        case 'holderApproval':
          return this.$store.getters.getPayoutsHolderApprovalPendingIsLoading;
        case 'bankTransferApproval':
          return this.$store.getters.getPayoutsBankTransferApprovalPendingIsLoading;
        case 'finalCheckApproval':
          return this.$store.getters.getPayoutsFinalCheckApprovalPendingIsLoading;
        default:
          return 0;
      }
    },
    refresh() {
      this.$store.dispatch('fetchPayoutAll', this.filterByType);
      this.$store.dispatch('fetchPayoutCreationTypes');
    },
    filterTypes() {
      return [
        { id: null, name: 'Alle Anzeigen' },
      ].concat(this.types());
    },
    types() {
      const data = this.$store.getters.getPayoutsCreationTypes;

      if (!data || !data.payout || !data.payout.types) {
        return [];
      }

      return this.transformEnumToSelectArray(data.payout.types);
    },
    transformEnumToSelectArray(options) {
      const newOptions = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(options)) {
        newOptions.push({
          id: key,
          name: value,
        });
      }

      return newOptions;
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/payoutsAndTaxes/payouts/PayoutsView.vue